import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useAwards() {
    const [awards, setAwards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchAwards = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/awards`, { withCredentials: true });
            const data = res.data?.awards ?? res.data ?? [];
            setAwards(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createAward = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/awards`, payload, { withCredentials: true });
            await fetchAwards();
            return res.data?.award;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchAwards]);

    const updateAward = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/awards/${id}`, payload, { withCredentials: true });
            await fetchAwards();
            return res.data?.award;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchAwards]);

    const deleteAward = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/awards/${id}`, { withCredentials: true });
            await fetchAwards();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchAwards]);

    useEffect(() => {
        fetchAwards();
    }, [fetchAwards]);

    return {
        awards,
        loading,
        error,
        fetchAwards,
        createAward,
        updateAward,
        deleteAward,
    };
}
